// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/Code/golang/andpro/ant-design-pro/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from 'D:/Code/golang/andpro/ant-design-pro/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from 'D:/Code/golang/andpro/ant-design-pro/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { SmileOutlined, CrownOutlined, TableOutlined };
